import FragmentPage from '../core/FragmentPage';

export default class CuotasPage extends FragmentPage {
  constructor(meta) {
    super('cuotas', meta);
  }
}
